import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { IReview } from '../../../shared/models/review';
import { ReviewService } from '../../../shared/services/review.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
  selector: 'rejection-reason',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    ReactiveFormsModule
  ],
  templateUrl: './rejection-reason.component.html',
  styleUrl: './rejection-reason.component.css'
})
export class RejectionReasonComponent implements OnInit {

  @Input() caseId: string | null = null;
  @Input() form_name: string | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<{note: string}>();

  rejectionForm: FormGroup = new FormGroup([]);

  loading: boolean = false;

  constructor() {}

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.rejectionForm = new FormGroup({
      note: new FormControl('', Validators.required)
    });
  }

  handleSendRequest(): void {
    if (this.rejectionForm.valid) {
      this.onSubmit.emit(this.rejectionForm.value);
    }
  }
  
  handleClose(): void {
    this.onClose.emit();
  }

}
